/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslocoModule } from '@jsverse/transloco';

import { faArchiveIcon } from 'IconLibrary/fontawesome/regular/archive';
import { faCaretSquareRightIcon } from 'IconLibrary/fontawesome/regular/caret-square-right';
import { faCloneIcon } from 'IconLibrary/fontawesome/regular/clone';
import { faCommentIcon } from 'IconLibrary/fontawesome/regular/comment';
import { faEllipsisHIcon } from 'IconLibrary/fontawesome/regular/ellipsis-h';
import { faExclamationSquareIcon } from 'IconLibrary/fontawesome/regular/exclamation-square';
import { faEyeIcon } from 'IconLibrary/fontawesome/regular/eye';
import { faEyeSlashIcon } from 'IconLibrary/fontawesome/regular/eye-slash';
import { faInboxIcon } from 'IconLibrary/fontawesome/regular/inbox';
import { faInfoCircleIcon } from 'IconLibrary/fontawesome/regular/info-circle';
import { faPaperPlaneIcon } from 'IconLibrary/fontawesome/regular/paper-plane';
import { faQuestionCircleIcon } from 'IconLibrary/fontawesome/regular/question-circle';
import { faTelegramPlaneIcon } from 'IconLibrary/fontawesome/brands/telegram-plane';
import { faTrashAltIcon } from 'IconLibrary/fontawesome/regular/trash-alt';
import { fasFlagIcon } from 'IconLibrary/fontawesome/solid/flag';
import { fasHistoryIcon } from 'IconLibrary/fontawesome/solid/history';

import { TooltipModule } from 'primeng/tooltip';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { AeroModule } from '../../aero/aero.module';
import { MenusModule } from '../menus/menus.module';
import { SVGIconModule } from '../svg-icon/svg-icon.module';

import { PageViewHeaderMenusComponent } from './page-view-header-menus/page-view-header-menus.component';
import { SharePanelModule } from '../share-panel/share-panel.module';
import { SubmitAssignmentModule } from '../submit-assignment/submit-assignment.module';

@NgModule({
  declarations: [
    PageViewHeaderMenusComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    AeroModule,
    MenusModule,
    SharePanelModule,
    TooltipModule,
    TranslocoModule,

    SVGIconModule,
    SubmitAssignmentModule,
    SvgIconComponent,
  ],
  exports: [
    PageViewHeaderMenusComponent,
  ],
  providers: [
    provideSvgIcons([
      faArchiveIcon,
      faCaretSquareRightIcon,
      faCloneIcon,
      faCommentIcon,
      faEllipsisHIcon,
      faExclamationSquareIcon,
      faEyeIcon,
      faEyeSlashIcon,
      faInboxIcon,
      faInfoCircleIcon,
      faPaperPlaneIcon,
      faQuestionCircleIcon,
      faTelegramPlaneIcon,
      faTrashAltIcon,
      fasFlagIcon,
      fasHistoryIcon,
    ]),
  ],
})
export class PageViewHeaderModule { }
